import ListaVentilador from "./ListaVentilador";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function VentiladorForm() {

    return (
        <AlertDialogOnClose nome={"Ventilador"} placeholder={"Insira o nome do ventilador"}>
            <ListaVentilador/>
        </AlertDialogOnClose>
    )
} 